import React, { useEffect, useState } from 'react';
import { Card, CardContent, CardHeader } from './ui/card';
import { Network, ArrowRight } from 'lucide-react';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from './ui/table';
import { useAuth } from '../context/AuthContext';

const ItemBomImpactCard = ({ itemId }) => {
  const { api } = useAuth();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!itemId) return;
    api().get(`/items/${itemId}/bom-impact`)
      .then(r => setData(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [itemId, api]);

  if (loading) return null;

  const totals = data?.totals || {};
  const boms = data?.boms || [];

  return (
    <Card className="industrial-card" data-testid="item-bom-impact-card">
      <CardHeader className="border-b border-slate-100 pb-3 flex-row items-center justify-between flex">
        <h2 className="text-sm font-semibold text-slate-700 flex items-center gap-2">
          <Network className="w-4 h-4" /> Used in BOMs
        </h2>
        <div className="text-xs text-slate-500 mono flex gap-3">
          <span data-testid="bom-impact-count">{totals.boms_count || 0} BOMs</span>
          <span data-testid="bom-impact-active-wo">{totals.active_work_orders || 0} active WO</span>
          <span data-testid="bom-impact-remaining-qty">{totals.remaining_qty_required || 0} units required</span>
        </div>
      </CardHeader>
      <CardContent className="p-0">
        {boms.length === 0 ? (
          <div className="p-6 text-center text-sm text-slate-500" data-testid="bom-impact-empty">
            This item is not part of any BOM yet.
          </div>
        ) : (
          <Table className="data-table">
            <TableHeader>
              <TableRow>
                <TableHead>Product</TableHead>
                <TableHead>BOM</TableHead>
                <TableHead>Status</TableHead>
                <TableHead className="text-right">Qty / Unit</TableHead>
                <TableHead className="text-right">Active WO</TableHead>
                <TableHead className="text-right">Remaining Need</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {boms.map(b => (
                <TableRow key={b.bom_id} data-testid={`bom-impact-row-${b.bom_id}`}>
                  <TableCell className="font-medium">{b.product_type_name}</TableCell>
                  <TableCell className="text-sm mono text-slate-600">
                    {b.bom_variant_code} <span className="text-slate-400">v{b.bom_revision}</span>
                  </TableCell>
                  <TableCell>
                    <span className={`status-badge ${b.bom_status === 'Released' ? 'status-released' : 'status-draft'}`}>
                      {b.bom_status}
                    </span>
                  </TableCell>
                  <TableCell className="text-right mono">{b.quantity_per_unit} {b.uom}</TableCell>
                  <TableCell className="text-right mono">{b.active_work_orders}</TableCell>
                  <TableCell className="text-right mono font-semibold">{b.remaining_qty_required}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </CardContent>
    </Card>
  );
};

export default ItemBomImpactCard;
